import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
	Container,
	Row,
	Col,
	Button,
	ButtonToolbar,
	ButtonGroup,
} from "reactstrap";
import { TabContent, Nav, NavItem, NavLink } from "reactstrap";

import "../../styles/COVID.css";
import data from "../../data/covid-projects.json";
import { Link, useHistory, useLocation } from "react-router-dom";
import IndoorPresenter from "./Cases/IndoorPresenter";
import Musicians from "./Cases/Musicians";
import SchoolBus from "./Cases/SchoolBus";
import CommercialBus from "./Cases/CommercialBus";
import Classroom from "./Cases/Classroom";
import AirplaneCabin from "./Cases/AirplaneCabin";
import OutdoorPresenter from "./Cases/OutdoorPresenter";
const scenarios = [
	{ id: "indoor-presenter", title: "Indoor Presenter", disabled: false },
	{ id: "musicians", title: "Musicians", disabled: false },
	{
		id: "outdoor-presenter",
		title: "Outdoor Presenter",
		disabled: true,
	},
	{ id: "school-bus", title: "School Bus", disabled: false },
	{ id: "bus", title: "Campus Bus", disabled: false },
	{ id: "classroom", title: "Classroom", disabled: false },
	{ id: "airplane", title: "Airplane Cabin", disabled: false },
].sort((a, b) => (b.disabled ? -1 : 1));

function COVID() {
	const [activeTab, setActiveTab] = useState(scenarios[0].id);
	const history = useHistory();
	const { pathname, search } = useLocation();
	useEffect(() => {
		let s = new URLSearchParams(search);
		if (s.has("case")) {
			if (s.get("case") !== activeTab) {
				setActiveTab(s.get("case"));
			}
		}
	}, [search]);
	const toggle = (tab) => {
		if (activeTab !== tab) {
			history.replace({
				pathname,
				search: new URLSearchParams({ case: tab }).toString(),
			});
			setActiveTab(tab);
		}
	};
	return (
		<Container>
			<h1 style={{ textAlign: "center" }}>City@UMD COVID-19</h1>

			<Row>
				<Col xs={12}>
					<Row>
						<Col sm={12} md={8}>
							<h3>COVID-19 Infection Risk Scenarios</h3>
							<p>
								The following are various airborne infection risk scenarios for
								COVID-19 that City@UMD researchers have analyzed.
							</p>
						</Col>
						<Col sm={12} md={4}>
							<Button
								outline
								color="primary"
								style={{ width: "100%", margin: 4 }}
								href="/covid-19/faqs"
							>
								COVID-19 FAQs
							</Button>
							<Button
								outline
								color="primary"
								style={{ width: "100%", margin: 4 }}
								tag={Link}
								to="/covid-19/ask-question"
							>
								Submit A COVID-19 Question
							</Button>

							<Button
								outline
								size="sm"
								color="info"
								style={{ width: "100%", margin: 4 }}
								href="https://giving.umd.edu/giving/fund.php?name=cityumd-gift-fund "
								target="_blank"
							>
								Donate to City@UMD
							</Button>
						</Col>
					</Row>
				</Col>

				<Col xs={12}>
					<div>
						<Nav tabs>
							{scenarios
								.filter((sc) => !sc.disabled)
								.map((sc, i) => (
									<NavItem key={i}>
										<NavLink
											className={clsx({ active: activeTab === sc.id })}
											onClick={() => {
												toggle(sc.id);
											}}
											disabled={sc.disabled}
										>
											{sc.title}
										</NavLink>
									</NavItem>
								))}
						</Nav>
						<TabContent
							activeTab={activeTab}
							style={{ backgroundColor: "#fff", overflowX: "hidden" }}
							className="nav-tabs"
						>
							<IndoorPresenter />
							<Musicians />
							<SchoolBus />
							<CommercialBus />
							<Classroom />
							<AirplaneCabin></AirplaneCabin>
							<OutdoorPresenter></OutdoorPresenter>
						</TabContent>
					</div>
				</Col>
			</Row>
			<hr />
			<Row>
				<Col sm={12} md={12}>
					<p>
						Public performances such as the Presidential and Vice Presidential
						debates can add a layer of protection from COVID-19 with a simple
						but effective technical solution.
					</p>
				</Col>
				<Col sm={12} md={6}>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<Button
							color="primary"
							style={{ width: 450, margin: 4 }}
							target="_blank"
							href={`${process.env.PUBLIC_URL}/uploads/LettertoCommissiononPresidentialDebates.pdf`}
						>
							Letter to Commission on Presidential Debates
						</Button>
					</div>
				</Col>
			</Row>
			<hr />
			<h2 style={{ marginBottom: 4 }} className="text-center">
				Projects
			</h2>
			{data.map((project, i) => (
				<div key={i}>
					<h3>{project.title}</h3>
					<Row>
						<Col xs="12" md="8">
							<h4 style={{ color: "grey" }}>{project.subtitle}</h4>
							<p>{project.text}</p>
						</Col>
						<Col xs="12" md="4">
							<img
								src={`${process.env.PUBLIC_URL}/${project.image}`}
								alt=""
								className="img-fill"
							/>
							<div
								style={{ margin: 8, display: "flex", justifyContent: "center" }}
							>
								<ButtonToolbar>
									<ButtonGroup>
										{project.links.map((link, i) => (
											<Button outline color="warning" key={i} href={link.href}>
												{link.text}
											</Button>
										))}
									</ButtonGroup>
								</ButtonToolbar>
							</div>
						</Col>
					</Row>
				</div>
			))}
		</Container>
	);
}

export default COVID;
